var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.391 46.752c.624 0 1.128.216 1.512.648.432.432.648.936.648 1.512 0 .624-.216 1.128-.648 1.512-.384.384-.888.576-1.512.576H2.967c-.624 0-1.152-.192-1.584-.576-.384-.432-.576-.96-.576-1.584V2.76c0-.624.192-1.128.576-1.512C1.815.816 2.343.6 2.967.6h26.424c.624 0 1.128.216 1.512.648.432.384.648.888.648 1.512s-.216 1.128-.648 1.512c-.384.384-.888.576-1.512.576H5.343V22.92h20.808c.624 0 1.128.216 1.512.648.432.384.648.888.648 1.512s-.216 1.128-.648 1.512c-.384.384-.888.576-1.512.576H5.343v19.584h24.048z",
    fill: "currentColor"
  })));
}
export default SvgE;